import ReactGA from "react-ga4";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLogout, useCurrentUser, useFetchGroups } from "utils/hooks";
import { updateGroupAction } from "store/actions/groups";

const useArchiveGroup = () => {
  const { user } = useCurrentUser();
  const dispatch = useDispatch();
  const { logOut } = useLogout();
  const { fetchGroups } = useFetchGroups();
  const history = useNavigate();

  const submitArchiveGroup = async (groupId: string) => {
    if (!groupId) {
      return;
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}`, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          query: `
            mutation {
              archiveGroup(groupId: "${groupId}") {
                uuid
                name
                description
                slug
                location
                address {
                  address1
                  address2
                  city
                  state
                  country
                }
                status
                createdAt
                practiceId
                therapistHistory {
                  therapistId
                  assignedAt
                  unassignedAt
                }
              }
            }
          `,
        }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          organizationId: user?.activeOrganizationId || "NA",
          permissionKey: "archive_groups",
        },
      });

      const resData = await res.json();

      if (res.ok) {
        fetchGroups();
        toast("Your group has been archived");
        ReactGA.event("group_archived_success", {
          user_id: user?.id,
          group_id: groupId,
        });
        dispatch(updateGroupAction(resData.data.archiveGroup));
        return history("/groups/archived");
      }

      if (!res.ok) {
        if (resData.errors[0].message.includes("BRKN_6001")) {
          toast.warn("For security purposes please log in again.");
          logOut();
        } else {
          toast.error(
            `Hmm, something went wrong. ${resData.errors[0].message}`
          );
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  return {
    submitArchiveGroup,
  };
};

export default useArchiveGroup;
